module.exports = __webpack_public_path__ + "static/media/LogoDefinitivo.cf7cdb01.png";